import { Component, OnInit, Input, HostBinding } from '@angular/core';

interface IProperty<T> {
  value: T;
}
interface TextPanelData {
  description?: IProperty<String>,
  link?: IProperty<Object>;
  panelSettings?: any;
  anchor: IProperty<string>;
}

@Component({
  selector: 'app-text-panel',
  templateUrl: './text-panel.component.html',
  styleUrls: ['./text-panel.component.less']
})
export class TextPanelComponent implements OnInit {
  @Input() data: TextPanelData;
  @HostBinding('class') rootClasses;

  constructor() { }

  ngOnInit() {
    this.rootClasses = `
      ${ this.data.panelSettings.theme.value.alias || 'default-theme' }
      ${ this.data.panelSettings.behaviour.value || 'full-content' }
    `;
  }
}
